// extracted by mini-css-extract-plugin
module.exports = {"container":"WeightUnit_container__dKWPK","weightUnit":"WeightUnit_weightUnit__BIcDK"};